import { transition, trigger } from '@angular/animations';

import { AnimationTransition, applyFadeInAnimation } from '../../core/animations';

export const ImagesPreviewModalPageAnimations = [
  trigger('animatedImage', [transition(AnimationTransition.VoidToAny, applyFadeInAnimation({ duration: 600, delay: 300 }))]),
];
